// Thin client for the phonebook (rubrica) endpoints in user-service.
// One phonebook per module; the server enforces module access + edit roles.

import api from './api';

export const phonebookApi = {
  // One module's phonebook (paginated, searchable by name or number).
  list: ({ moduleId, search = '', page = 1, limit = 25 }) => {
    const params = new URLSearchParams({ module_id: moduleId, page: String(page), limit: String(limit) });
    if (search) params.set('search', search);
    return api.get(`/phonebook?${params.toString()}`);
  },

  // Typeahead across the requester's accessible phonebooks (name OR number).
  search: (q, moduleId) => {
    const params = new URLSearchParams({ q });
    if (moduleId) params.set('module_id', moduleId);
    return api.get(`/phonebook/search?${params.toString()}`);
  },

  // Caller-ID resolution for an inbound/outbound number.
  lookup: (number) => api.get(`/phonebook/lookup?number=${encodeURIComponent(number)}`),

  create: (payload) => api.post('/phonebook', payload),
  update: (id, payload) => api.put(`/phonebook/${id}`, payload),
  // Append number(s) to an existing entry (merge). Allowed for any module
  // member, OPERATOR included — it's an add, not an edit.
  addNumbers: (id, numbers) => api.post(`/phonebook/${id}/numbers`, { numbers }),
  remove: (id) => api.delete(`/phonebook/${id}`),
};

export default phonebookApi;
